/* global global Set */

// Local imports
// polyfills must be applied before everything else
import '../../polyfill/index.js';

import * as donation_mod from '../../donation/init.js';
import * as global_mod from '../../global/index.js';
import * as tealium from '../../datalayer/tealium.js';
import { PAGE_VARS, PageKind } from '../vars.js';
import axios from 'axios';
import Shopify from 'shopify_api';

import * as shopify_data from './shopify_data.js';
import { renameProperties } from '../../util/postDonationProduct.js';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'specialgift';

export let global_vars = {};

// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------

class ShopifyData {
    constructor(data_element) {
        this.data_element = data_element;
    }

    run() {
        let data = this.data_element.dataset;
        shopify_data.save_specialgift_childid(data.child_id_str);
    }
}

function init_pagevars() {
    PAGE_VARS.kind = PageKind.Donation;
}

function validate_data(childid, name, amount) {
    let min_amount =
        global.document.forms['special_gifts_form'].elements[
            'properties[min_amount]'
        ].value;
    let errmsg = '';
    if (!childid.match(/^\d{1,6}-\d{1,4}$/)) {
        errmsg =
            'Invalid child ID, expected child_id in ' +
            `format 123456-1234, instead got: ${childid}`;
    } else if (!name.trim()) {
        errmsg = 'Received empty value for child first name';
    } else if (parseInt(amount).toString() !== amount) {
        errmsg = `Invalid value for amount: ${amount}`;
    } else if (parseInt(amount) < min_amount) {
        errmsg = `Invalid value amount, expected value equal or greater than minimum. Instead got: ${amount}`;
    }

    if (errmsg) {
        throw new Error(errmsg);
    }
}

// Get properties from hidden inputs in the form and add the data for each child
function get_properties(form, id, name, amount) {
    let elements = global.document.forms[form].elements;
    let properties = {};
    //Added this property to consider the quantity as 1 and with proper amount in CE
    properties["donation_quantity_fix"]="true";
    for (let i = 0; i < elements.length; i++) {
        let match = elements[i].name.match(/^properties\[(.*)\]$/);
        if (match !== null) {
            let key = match[1];
            switch (key) {
                case 'child_id':
                    properties[key] = id;
                    break;
                case 'child_name':
                    properties[key] = name;
                    break;
                case 'amount':
                    properties[key] = amount;
                    break;
                default:
                    properties[key] = elements[i].value;
            }
        }
    }
    return properties;
}

// url must include all of the following parameters (note parameter names are
// case sensitive):
//
// child_id: 123456-1234
// child_name: John
// amount: 100
//
function dispatch_on_childid(global) {
    let form_name = 'special_gifts_form';
    let id = global.document.forms[form_name].elements.id.value;
    let url_params = get_url_params(global);
    let children = url_params['children'];
    Shopify.queue = [];

    children.forEach(function(child) {
        // Throw an error if any of the required url parameters are missing
        if (
            child === null ||
            child === undefined ||
            child.child_id === null ||
            child.child_id === undefined ||
            child.child_name === null ||
            child.child_name === undefined ||
            child.amount === null ||
            child.amount === undefined
        ) {
            let err = new Error(
                `Missing required url parameter. Data incomplete: ${child}`
            );
            throw err;
        }

        validate_data(child.child_id, child.child_name, child.amount);
        console.log('Amount::'+child.amount)
        // If child is valid, push to the queue
        Shopify.queue.push({
            id: id,
            quantity: child.amount,
            properties: get_properties(
                form_name,
                child.child_id,
                child.child_name,
                child.amount
            ),
        });
    });

    Shopify.moveAlong = function() {
        // If there are requests in the queue, process the next one
        if (Shopify.queue.length) {
            let request = Shopify.queue.shift();
            Shopify.addItem(
                request.id,
                request.quantity,
                request.properties,
                Shopify.moveAlong
            );
        }
        // If the queue is empty, redirect to the cart page
        else {
            global.location = '/cart';
        }
    };

    Shopify.addItem = function(id, qty, properties, callback) {
        let renamedProperties = {};
    //Adding the donation_quantity_fix as we are considering the amount as quantity
    //data.properties.donation_quantity_fix = true;
    for (let [key, value] of Object.entries(properties)) {
        //If the properties does not have _ then only add _(underscore) to hide the properties in checkout page
        if(!key.startsWith('_')) {
            renamedProperties['_' + key] = value;
        }
    }
        let params = {
            quantity: qty,
            id: id,
        };
        if (properties !== null) {
            params.properties = renamedProperties;
        }
        let url = '/cart/add.js';
        axios
            .post(url, params)
            .then(() => {
                if (typeof callback === 'function') {
                    callback();
                }
            })
            .catch(data => {
                let err = {
                    msg: `POST failed for url: ${url}`,
                    data,
                };
                throw err;
            });
    };

    // Start processing the queue
    Shopify.moveAlong();
}

function get_url_params(global) {
    let url = global.location.href;
    let paramString = url.split('?')[1];
    if (!paramString) return { children: [] };
    paramString = paramString.split('&');

    // Unique param that identifies a new child
    let key_param = 'child_id';
    // Other params of a child
    let child_params = ['child_name', 'amount'];
    let params = {};
    let children = [];
    // Set of childIds that are already in the cart
    let childSet = new Set(shopify_data.SHOPIFY_DATA.childid);
    let ignoreEntry = false;

    paramString.forEach(function(paramPart) {
        let param = paramPart.split('=');
        let key = decodeURIComponent(param[0]);
        let value = decodeURIComponent(param[1]);
        if (key === key_param) {
            // If it's a duplicated childId, ignore any params until it finds a new childId
            ignoreEntry = childSet.has(value);
            if (!ignoreEntry) {
                children.push({ [key]: value });
                childSet.add(value);
            }
        } else if (child_params.includes(key)) {
            if (!ignoreEntry && children.length >= 1) {
                children[children.length - 1][key] = value;
            }
        } else {
            params[key] = value;
        }
    });
    params.children = children;
    return params;
}

function initialize(global) {
    let data_element = global.document.getElementById('specialgift-data');
    let shpdata = new ShopifyData(data_element);
    shpdata.run();

    dispatch_on_childid(global);
}

export function main() {
    // Initialize all page vars
    init_pagevars();

    let all_modules = [];
    all_modules.push.apply(all_modules, global_mod.__all__);

    // Create object to pass to global initialization
    let special_gift_mod = {
        MODULE_NAME,
        global_vars,
        initialize,
    };

    // Initialize donation module and special gifts module after all global
    // modules
    all_modules.push(donation_mod, special_gift_mod);

    // Insert datalayer setup module and tealium module at the beginning and end
    // of the modules array respectively
    all_modules = tealium.wrap_module_array(all_modules);

    // Initialize globals
    // The ``global`` global variable will be ``window`` when run in a browser
    // context.
    global_mod.initialize(global, all_modules);
}
